// 正式环境（代码构建）
export const isProd = process.env.NODE_ENV === "production";

// 生产环境（运行时）
export const isOnline = window.location.host.startsWith('m.didipay.com');

// 预发生产环境（运行时）
export const isPre = window.location.host.startsWith('m.intra.didipay.com');

// URL参数
const queryParams = new URLSearchParams(window.location.search);

// 判断是否端内还是端外
export const inApp: boolean = /(sofiwebview|fusionkit)/i.test(navigator.userAgent);
// 判断是否是iphone
export const isIPhone: boolean = /iphone/i.test(navigator.userAgent);
// sofipo 端外terminal id
export const SOFI_TERMINAL_ID: number | string = queryParams.get('terminal_id') || 300316;
// 
export const SOFI_SDK_VERSION: string = queryParams.get('sofipo_sdk_version') || "";
// 端版本号
export const SOFI_APP_VERSION: string = queryParams.get('appversion') || "";
// 集团安全SDK App ID
export const WSGENV_APP_ID: string = '02040712';
// from type枚举
export enum FromTypeEnum {
    NATIVE,
    WEB,
    MINI_APP,
    PC,
};
// 端类型
export const CLIENT_TYPE = FromTypeEnum.WEB;
// 公共前缀
export const BASE_PATH: string = process.env["BASE_PATH"] || "";

// 风控核验因子
export enum RiskFactor {
    FACE_REC_VERIFY = 'FACE_REC_VERIFY', 
    CPF_VERIFY = 'CPF_VERIFY',
    CARD_VERIFY = 'CARD_VERIFY',
    EMAIL_VERIFY = 'EMAIL_VERIFY',
    SMS_VERIFY = 'SMS_VERIFY',
    FULL_KYC_VERIFY = 'FULL_KYC_VERIFY',
    CURP_VERIFY = 'CURP_VERIFY',
    BIO_VERIFY = 'BIO_VERIFY',
    SMS = 'SMS',
    /**
     * WhatsApp 渠道触达 （本次新增核验因子）
     * 通过 WhatsApp 触达用户并完成校验
     */
    WHATSAPP_VERIFY = 'WHATSAPP_VERIFY',
    NOTHING = '',
}
// 风控核验状态
export enum VerifyStatus {
    SUCCESS = 'success',
    FAIL = 'fail',
    LIMIT = "limit",
}

// 所有环境配置
const Configs = {
    production: {
        // 钱包服务域名 @julyzhu
        publicAPIPath: "https://wallet.didipay.com",
        // 风控服务域名 @maryzhang
        publicRiskAPIPath: "https://payrisk.didipay.com",
        // waiting list domain @张超超
        publicConductAPIPath: "https://conduct.didipay.com",
    },
    pre: {
        // 钱包服务域名 @julyzhu
        publicAPIPath: "https://sofipo-api-pre.didipay.com",
        // 风控服务域名 @maryzhang
        publicRiskAPIPath: "https://payrisk-pre.didipay.com",
        // waiting list domain @张超超
        publicConductAPIPath: "https://conduct.didipay.com",
    },
    development: {
        // publicAPIPath: 'http://xmock.intra.xiaojukeji.com/mock/420',
        publicAPIPath: "",
        // publicAPIPath: "/digitalbank/conduct",
        publicRiskAPIPath: "",
        // waiting list domain @张超超
        publicConductAPIPath: "/digitalbank/conduct",
        // publicAPIPath: "//dsim365-api.intra.xiaojukeji.com",
    },
};


// 当前配置
export const DefaultConfigs = isOnline ? Configs.production : isPre ? Configs.pre : Configs.development;

interface LangObj {
    [key: string]: {
        locale: string;
        antdLocale: string;
    };
}

const langObj: LangObj = {
    "zh-CN": {
        locale: "zh",
        antdLocale: "zh-CN",
    },
    zh: {
        locale: "zh",
        antdLocale: "zh-CN",
    },
    "es-MX": {
        locale: "mx",
        antdLocale: "es-MX",
    },
    "en-US": {
        locale: "en",
        antdLocale: "en-US",
    },
};

const getAntdLocale = (language: string): string => {
    const antdLocale = langObj.hasOwnProperty(language) ? langObj[language].antdLocale : "";
    return antdLocale;
};
// 优先URL公参语言 
const lang: string = queryParams.get('lang') || navigator.language;

// 获取默认语言
export const defaultLanguage: string = getAntdLocale(lang) || "es-MX";
export const defaultLocale: string = getAntdLocale(lang) || "es-MX";
export const DATE_FORMAT = "YYYY-MM-DD";

export const setUrl = ((url:string)=>{
  return url
})

// 西班牙字母（姓名）
export const nameLetter: string = 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZÁÉÍÓÚÜÝÏabcdefghijklmnñopqrstuvwxyzáéíóúüýï';

// //从未开过户
// NO_CREATE(0, Collections.singletonList(-1), ""),
// //已开户成功
// CREATE_SUCCESS(1, Collections.singletonList(CreateAcctStatusEnum.SUCCESS.getStatus()), ""),
// //开户失败
// CREATE_FAILED(2, Arrays.asList(CreateAcctStatusEnum.INIT.getStatus(), CreateAcctStatusEnum.FAILED.getStatus()), ""),
// //开户审核中
// KYC_PENDING(3, Arrays.asList(CreateAcctStatusEnum.RISK_PENDING.getStatus(), CreateAcctStatusEnum.RISK_SUCCESS.getStatus()), ""),
export enum EnumAccountStatus {
    NO_CREATE,
    CREATE_SUCCESS,
    CREATE_FAILED,
    KYC_PENDING
}

// sofi品牌名称
export const SOFI_BRAND_NAME = 'DiDi Cuenta';
// 默认城市ID
// export const MX_CITY_ID = Number(queryParams.get('cityId')) || 52151600;
// H5固定City ID；解决Elvish不识别city id报错；
export const MX_CITY_ID = 52151600;

// 是否需要扣税
export enum TAX_DEDUCTION_TYPE {
    none = 0,  // 不展示i
    need = 1,    // 需要税扣
    noNeed = 2,  // 不需要税扣
}

// 是否达到生物核验次数上限
export enum IsReachLimitStatus {
    NO = 0, // 否
    YES = 1, // 是
}

// 生物核验结果
export enum BioVerifyStatus {
    SUCCESS = 1, // 成功
    FAIL = 0, // 失败
}

// 生物核验次数限制来源
export enum LimitSource {
    SYSTEM = 'system', // 系统
    BACKEND = 'backend' // 后端
}

// 生物识别类型
const BioType: Record<number, string> = {
  0:'biology',
  1:'face',
  2:'finger'
}
export const getBiotype = (biologyType?: number): string => {
    if (biologyType === undefined || typeof biologyType !== 'number') {
        return '';
    }
    return BioType[biologyType] || '';
};

export enum ProfileButtonType {
 //   税务信息
 FISCAL_INFORMATION = 'fiscal_information',
//  account_id说明
 ACCOUNT_ID = 'account_id',
//  复制account_id
 COPY_ACCOUNT_ID = 'account_id_copy',
//  返回
 BACK = 'back',
//  展开信息
 DISPLAY = 'display',
//  隐藏信息
 HIDE = 'hide'
}